import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './Components/SideBar';
import { SidebarProvider } from './SidebarContext';
import AllUsers from './Components/AllUsers';
import Articles from './Components/Articles';
import ContactTable from './Components/ContactTable';
import PaymentHistoryTable from './Components/PaymentHistoryTable';
import Login from './Components/Login';
import ResetPassword from './Components/ResetPassword';
import Plan from './Components/Plan';
import News from './Components/News';
import Coupon from './Components/Coupon';
import { ToastContainer } from 'react-toastify';
import CouponUsage from './Components/CouponUsage';
import Volume from './Components/Volume';
import Issues from './Components/Issues';
import VideoUploadForm from './Components/VideoForm/VideoDetail';
import Content from './Components/Content';
import Event from './Components/Event/Event';
import Analytics from './Components/Analytics/Analytics';
import SingleAnalytics from './Components/Analytics/SingeAnalytics';
import BoostHistoryTable from './Components/Boost/BoostHistory';
import AllStaff from './Components/Staff/Staff';
import StaffEarningSettings from './Components/Settings/Setting';
import Earning from './Components/Earning/Earning';
import SingleEarning from './Components/Earning/SingleEarning';
import LeaderboardList from './Components/Leaderboard/Ranking';
import EarningEvent from './Components/Earning/EarningEvent';
import { useNavigate } from "react-router-dom"
import { useEffect } from 'react';
import Withdraw from './Components/Withdraw/Withdraw';

// utils/auth.js
// utils/auth.js
export const isUserLoggedIn = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT payload
    const exp = payload.exp * 1000; // exp is in seconds, convert to ms
    return Date.now() < exp; // true = valid, false = expired
  } catch (err) {
    return false; // invalid token
  }
};


const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isLoggedIn = isUserLoggedIn();
  // redirect if token expired
  useEffect(() => {
    if (!isLoggedIn) {
      localStorage.removeItem("token");
      navigate("/login");
    }
  }, []);

  return (
    <SidebarProvider>
      <div className="app-container">
        {/* Show sidebar if logged in */}
        {isLoggedIn && <Sidebar />}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="main-content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/upload" element={<VideoUploadForm />} />
            {/* Protected Routes */}
            {/* <Route path="/" element={isLoggedIn ? <Articles /> : <Navigate to="/login" />} /> */}
            <Route path="/all-users" index element={isLoggedIn ? <AllUsers /> : <Navigate to="/login" />} />
            <Route path="/content" element={isLoggedIn ? <Content /> : <Navigate to="/login" />} />
            <Route path="/analytics" element={isLoggedIn ? <Analytics /> : <Navigate to="/login" />} />
            <Route path="/analytics/:id/:videoId" element={isLoggedIn ? <SingleAnalytics /> : <Navigate to="/login" />} />
            <Route path="/contact" element={isLoggedIn ? <ContactTable /> : <Navigate to="/login" />} />
            <Route path="/payment-history" element={isLoggedIn ? <PaymentHistoryTable /> : <Navigate to="/login" />} />
            <Route path="/plan" element={isLoggedIn ? <Plan /> : <Navigate to="/login" />} />
            <Route path="/volume" element={isLoggedIn ? <Volume /> : <Navigate to="/login" />} />
            <Route path="/issue" element={isLoggedIn ? <Issues /> : <Navigate to="/login" />} />
            <Route path="/news" element={isLoggedIn ? <News /> : <Navigate to="/login" />} />
            <Route path="/coupon" element={isLoggedIn ? <Coupon /> : <Navigate to="/login" />} />
            <Route path="/event" element={isLoggedIn ? <Event /> : <Navigate to="/login" />} />
            <Route path="/boostvideo" element={isLoggedIn ? <BoostHistoryTable /> : <Navigate to="/login" />} />
            <Route path="/couponusage" element={isLoggedIn ? <CouponUsage /> : <Navigate to="/login" />} />
            <Route path="/staff-earning" element={isLoggedIn ? <Earning /> : <Navigate to="/login" />} />
            <Route path="/staff-earning/:id" element={isLoggedIn ? <SingleEarning /> : <Navigate to="/login" />} />
            <Route path="/setting" element={isLoggedIn ? <StaffEarningSettings /> : <Navigate to="/login" />} />
            <Route path="/leaderboard" element={isLoggedIn ? <LeaderboardList /> : <Navigate to="/login" />} />
            <Route path="/event-earning" element={isLoggedIn ? <EarningEvent /> : <Navigate to="/login" />} />
             <Route path="/withdraw" element={isLoggedIn ? <Withdraw /> : <Navigate to="/login" />} />
            {/* Catch-all route */}
            <Route path="/staff" element={isLoggedIn ? <AllStaff /> : <Navigate to="/login" />} />
            <Route path="*" element={<Navigate to={isLoggedIn ? "/" : "/login"} />} />
          </Routes>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </SidebarProvider>
  );
};

export default App;
